// extracted by mini-css-extract-plugin
module.exports = {"showingBack":"az_uJb","fontFamCond":"az_vJb","titleSection":"az_wJb","slimTitleSection":"az_xJb","shelfTitle":"az_yJb","shortDescription":"az_zJb"};